import React, { Component, Fragment, useState, useEffect } from "react";

import Header from "../../components/Header";
import Footer from "../../components/Footer";
import Sidebar from "../../components/Sidebar";
import { useDispatch } from "react-redux";
import { useTranslation, I18nextProvider } from "react-i18next";
import sta1 from "../../assets/images/sta_1.svg";
import sta2 from "../../assets/images/sta_2.svg";
import sta3 from "../../assets/images/sta_3.svg";
import sta4 from "../../assets/images/sta_4.svg";
import sta5 from "../../assets/images/sta_5.svg";
import sta6 from "../../assets/images/sta_6.svg";
import { useCustomizeContext } from "../../context";

import {
  getActiveGames,
  getActiveCurrency,
  getstatisticsdata,
} from "../../Features/GameCommon/gameCommonSlice";
import { getUserStatistics } from "../../Features/Statistics/statisticsSlice";


const Statistics = (props) => {
  const { t, i18n } = useTranslation();

  const {
    loader: { loading, setLoading },
    sideMenu: {
      classIsActive, setClassIsActive
    },
  } = useCustomizeContext();

  const [gameList, setGameList] = useState([]);
  const [currencyList, setCurrencyList] = useState([]);

  const [statisticsres, setStatisticsres] = useState([]);

  const [statisticsdata, setStatisticsdata] = useState({});

  useEffect(() => {
    document.body.classList.remove("SideMenuOpen");
  }, []);


  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    setClassIsActive(false);
    document.body.classList.remove("SideMenuOpen");
  }, []);

  let dispatch = useDispatch();

  useEffect(() => {
    getGameLists();
    getCurrencyLists();
  }, []);

  useEffect(() => {
    if (statisticsdata?.currency_id && statisticsdata?.game_id) {
      statisticslist();
    }
  }, [statisticsdata]);

  const statisticslist = async () => {
    let data = {
      currency_id: statisticsdata?.currency_id,
      game_id: statisticsdata?.game_id,
    };
    setLoading(true);
    setTimeout(async () => {
      let res = await dispatch(getUserStatistics(data));
      if (res?.status) {
        setStatisticsres(res?.data);
        setLoading(false);
      }
      else {
        setLoading(false);
      }
    }, 500);
  };

  const getGameLists = async () => {
    let data = {
      type: "user",
    };
    setLoading(true);
    let res = await dispatch(getActiveGames(data));
    setTimeout(() => {
      if (res?.status) {
        setGameList(res?.data);
        setStatisticsdata((data1) => ({
          ...data1,
          game_id: res?.data[0]?._id,
        }));
        setLoading(false);
      } else {
        setLoading(false);
      }
    }, 1000);
  };

  const getCurrencyLists = async () => {
    let data = {
      type: "user",
    };
    setLoading(true);
    let res = await dispatch(getActiveCurrency(data));
    setTimeout(() => {
      if (res?.status) {
        setCurrencyList(res?.data);
        setStatisticsdata((data1) => ({
          ...data1,
          currency_id: res?.data[0]?._id,
        }));
        setLoading(false);
      } else {
        setLoading(false);
      }
    }, 1000);
  };

  return (
    <Fragment>
      <Header />
      <div class="mainbody-content">
        <Sidebar />
        <div class="center-maincnt">
          <div class="inr-container">
            <div class="center-inrcnt">
              <div className="statisticspage-maincnt">
                <section class="statistics_sec_1 ">
                  <div class="d-flex align-items-center justify-content-between flex-wrap">
                    <div class="mb-3 mr-2">
                      <h2 class="mb-0">{t("Statistics")}</h2>
                    </div>
                    <div className="d-flex flex-wrap flex-md-nowrap flex-grow-1">

                      <div class=" drp_down d-flex flex-wrap flex-sm-nowrap  align-items-center mb-3 mr-md-2 w-100">
                        <h1 class="mr-2 mb-sm-0">{t("Currency")}</h1>
                        <div class="form-group mb-0  w-100">
                          <select
                            class="form-control"
                            id="exampleFormControlSelect1"
                            onChange={(e) => {
                              setStatisticsdata({
                                ...statisticsdata,
                                currency_id: e.target.value,
                              });
                            }}
                          >
                            {currencyList &&
                              currencyList?.map((temp, index) => (
                                <option key={index} value={temp?._id}>
                                  {temp?.currency_name}
                                </option>
                              ))}
                          </select>
                        </div>
                      </div>

                      <div class=" drp_down d-flex flex-wrap flex-sm-nowrap align-items-center mb-3 w-100">
                        <h1 class="mr-2 mb-sm-0">{t("Game")}</h1>
                        <div class="form-group mb-0  w-100">
                          <select
                            class="form-control"
                            onChange={(e) => {
                              setStatisticsdata({
                                ...statisticsdata,
                                game_id: e.target.value,
                              });
                            }}
                            id="exampleFormControlSelect1"
                          >
                            {gameList &&
                              gameList?.map((temp, index) => (
                                <option key={index} value={temp?._id}>
                                  {temp?.game_name}
                                </option>
                              ))}
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-lg-4 col-md-6 nd-mar ">
                      <div class="card_sta">
                        <div class="d-flex align-items-center">
                          <div class="in-img text-center mr-3">
                            <img class="img-fluid" src={sta3} alt="" />
                          </div>
                          <div>
                            <h3>{t("Number of wins")}</h3>
                            <h4>{statisticsres?.wins?.toFixed(2)}</h4>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-4 col-md-6 nd-mar">
                      <div class="card_sta card_sta_2">
                        <div class="d-flex align-items-center">
                          <div class="in-img text-center mr-3">
                            <img class="img-fluid" src={sta2} alt="" />
                          </div>
                          <div>
                            <h3>{t("Number of loss")}</h3>
                            <h4>{statisticsres?.loss?.toFixed(2)}</h4>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-4 col-md-6 nd-mar">
                      <div class="card_sta card_sta_3">
                        <div class="d-flex align-items-center">
                          <div class="in-img text-center mr-3">
                            <img class="img-fluid" src={sta6} alt="" />
                          </div>
                          <div>
                            <h3>{t("Total Profit Earned")}</h3>
                            <h4>{statisticsres?.total_profit?.toFixed(3)}</h4>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-4 col-md-6 nd-mar">
                      <div class="card_sta card_sta_4">
                        <div class="d-flex align-items-center">
                          <div class="in-img text-center mr-3">
                            <img class="img-fluid" src={sta5} alt="" />
                          </div>
                          <div>
                            <h3>{t("Biggest Win by Profit")}</h3>
                            <h4>{statisticsres?.bigges_win_profit?.toFixed(3)}</h4>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-4 col-md-6 nd-mar">
                      <div class="card_sta card_sta_5">
                        <div class="d-flex align-items-center">
                          <div class="in-img text-center mr-3">
                            <img class="img-fluid" src={sta1} alt="" />
                          </div>
                          <div>
                            <h3>{t("Lowest Win by Profit")}</h3>
                            <h4>{statisticsres?.lowest_win_profit?.toFixed(2)}</h4>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-4 col-md-6 nd-mar">
                      <div class="card_sta card_sta_6">
                        <div class="d-flex align-items-center">
                          <div class="in-img text-center mr-3">
                            <img class="img-fluid" src={sta4} alt="" />
                          </div>
                          <div>
                            <h3>{t("Completed game")}</h3>
                            <h4>{statisticsres?.no_of_playes?.toFixed(2)}</h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Statistics;
